import { init as engageInit } from '@sitecore/engage';
import { env } from 'lib/env';
import { getHostName } from 'lib/sitecore/utils';

// Derive settings type from SDK
export type EngageSettings = Parameters<typeof engageInit>[0];

const getCookieDomain = (): string | undefined => {
  const publicUrl = env.PUBLIC_URL;
  if (!publicUrl) {
    return undefined;
  }
  const host = getHostName(publicUrl);
  if (/localhost/.test(host)) {
    return undefined;
  }

  // Avoid returning IP addresses as cookie domains
  // We'e already asserted we trust host headers
  /* NOSONAR */ if (/^\d+(?:\.\d+){3}$/.test(host)) {
    // NOSONAR
    return undefined;
  }

  const parts = host?.split('.') || [];
  if (parts.length < 2) {
    return `.${host}`;
  }

  const topTwo = parts.slice(-2).join('.');
  return `.${topTwo}`;
};

// https://doc.sitecore.com/cdp/en/developers/api/settings-object.html
export const baseEngageSettings: Readonly<EngageSettings & { channel: string; currency: string }> =
  Object.freeze({
    clientKey: env.CDP_CLIENT_KEY,
    targetURL: env.CDP_ENGAGE_TARGET,
    pointOfSale: env.CDP_POINT_OF_SALE,
    forceServerCookieMode: false,
    webPersonalization: true,
    includeUTMParameters: true,
    channel: 'WEB',
    currency: 'USD',
    cookieDomain: getCookieDomain(),
    // If not running on an authenticated site, use a long-lived cookie.
    // When authentication is used, make the cookie expires in 24 hours,
    // and depend on the session event handlers to clear out on sign-out.
    cookieExpiryDays: env.SKIP_AUTHENTICATION ? 365 : 1,
  });
